export default "__VITE_PUBLIC_ASSET__1825e286__"